import React, { useState, useEffect } from "react";
import { CDBNavbar, CDBInput } from "cdbreact";
import axios from "axios";
import Dropdown from "react-bootstrap/Dropdown";
import "./Logout.css";
// import  logout  from "../images/cauris.png";
import { useHistory } from "react-router-dom";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import logo from "../images/cauris.png";

export const Logout = () => {
  const history = useHistory();
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );

  function reload() {}

  return (
    <div className="loginBox">
      <img src={logo} alt="" className="titleImage" />
      <h2> Credit Copilot</h2>
      <br />
      <div className="welcomeText">You have been logged out </div>
      <br />

      {/* <GoogleLogin onSuccess={responseMessage} onError={errorMessage} /> */}
      <a
        href={process.env.REACT_APP_FRONTEND_DOMAIN}
        className="reloadButton"
        onClick={reload}
      >
        Start Over
      </a>
      <p>&nbsp;</p>
    </div>
  );
};

export default Logout;
